import styled from "styled-components";

export const ScrollList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  padding-bottom: 15px;
`;

export const BoxItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-top: 80px;
  align-items: center;
  justify-content: center;

  :last-child {
    img {
      margin-left: 6px;
    }
  }
`;

export const Item = styled.div`
  background-color: white;
  padding: 16px;
  border-radius: 12px;
  display: flex;
  flex-direction: row;
  gap: 40px;
  align-items: center;
  justify-content: start;
  width: 470px;

  img {
    width: 120px;
    height: 120px;
  }

  p {
    color: #042b7e;
    text-transform: uppercase;
    font-size: 22px;
    font-weight: bold;
  }
`;

export const Back = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
  color: white;
  font-size: 20px;
  background-color: #042b7e;
  width: 60px;
  padding: 10px;
  margin-top: 20px;
  border-radius: 10px;
`;

export const BoxIndicators = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
  justify-content: center;
  margin: 40px 0;
  position: relative;

  input {
    color: #042b7e;
    font-size: 22px;
    padding-left: 10px !important;
    background-color: white !important;
    max-width: 150px;
    text-transform: capitalize;
  }

  fieldset {
    border: none !important;
  }
`;

export const BoxName = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;

  p {
    color: #042b7e;
    text-transform: uppercase;
    font-size: 22px;
    font-weight: 500;
  }
`;

export const MountTypography = styled.p`
  color: #042b7e;
  font-size: 22px;
  font-weight: 500;
`;

export const BoxInfoTop = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: top;
  justify-content: space-between;
  margin: 20px 0;
`;

export const BoxItemTop = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  background-color: white;
  padding: 12px;
  border-radius: 12px;
  width: 220px;
  position: relative;
`;

export const TitleTop = styled.p`
  color: #042b7e;
  font-size: 16px;
  font-weight: 500;
  text-align: center;
  height: 50px;
`;

export const ValueTop = styled.p`
  color: #042b7e;
  font-size: 36px;
  font-weight: 700;
  text-align: center;
`;

export const IsPatient = styled.p`
  color: #042b7e;
  font-size: 16px;
  font-weight: 500;
  text-align: end;
  height: 20px;
`;

export const LabelBottom = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
  justify-content: start;
  color: #042b7e;
  font-size: 13px;
  font-weight: 500;
`;

export const TopHome = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
  position: relative;

  span {
    color: #042b7e;
    font-size: 22px;
    font-weight: 700;
  }

  p {
    color: #042b7e;
    font-size: 16px;
    font-weight: 500;
    position: absolute;
    left: 0;
  }
`;

export const BoxButtons = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
  justify-content: start;
  width: 100%;
  margin-top: 20px;
`;

export const BoxAvaliation = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
  justify-content: space-between;
  background-color: white;
  padding: 5px;
  position: absolute;
  right: 0;

  p {
    color: #042b7e;
    font-size: 16px;
    font-weight: 700;
  }
`;

export const BoxMiddle = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

export const BoxMiddleItem = styled.div<{ isGauge?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 10px;
  background-color: white;
  padding: 16px;
  border-radius: 12px;
  width: 50%;
  height: ${(props) => (props.isGauge ? "auto" : "380px")};
  position: relative;
`;

export const BoxMiddleItemTitle = styled.p`
  color: #042b7e;
  font-size: 18px;
  font-weight: 500;
  text-align: center;
`;

export const BoxBottom = styled.div`
  width: 95%;
  background-color: white;
  padding: 16px;
  border-radius: 12px;
  margin: 20px 0;
  position: relative;
`;

export const TitleGauge = styled.p`
  color: #042b7e;
  font-size: 40px;
  font-weight: 700;
  text-align: center;
  margin-top: -60px;
`;

export const BoxGauge = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
  justify-content: space-between;
  margin-top: 35px;
`;

export const LabelGauge = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
  justify-content: space-between;

  span {
    color: #042b7e;
    font-size: 24px;
    font-weight: 700;
  }

  p {
    color: #042b7e;
    font-size: 14px;
    font-weight: 500;
  }
`;

export const BottomOthers = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin: 20px 0;
`;

export const OthersLeft = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 30%;
  background-color: white;
  padding: 16px;
  border-radius: 12px;
  height: 392px;
  justify-content: space-between;
  position: relative;
`;

export const OthersRight = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 70%;
  background-color: white;
  padding: 16px;
  border-radius: 12px;
  justify-content: center;
  align-items: center;
  height: 392px;
  position: relative;
`;
